import React, { useEffect, useState } from "react";
import { Navigate, Route } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AuthProtected = (props) => {
  
    let currentUser;
    if (sessionStorage.getItem('authUser')) {
        currentUser = JSON.parse(sessionStorage.getItem('authUser'));
    }

    if (currentUser) {
        if (jwtDecode(currentUser.token).exp > Date.now() / 1000) {
            if (
                currentUser.roles.includes('ADMIN') ||
                currentUser.roles.includes('SUPER_ADMIN')) {
                return <>{props.children}</>
            } else {
                return <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
            }
        } else {
            return <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
        }
    } else {
        return <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    }
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };